<div class="item__detail">
<div class="item__logo">
  <ng-container *ngIf="currentPartner === null || currentPartner === 'NONE'">
    <img class="partner-logo__img airline-logo-full" [ngClass]="airlinePartnerLogoName" [src]="getAirlineLogoUrl(productData.airlineName)" [alt]="productData.airlineName + ' logo'" />
  </ng-container>
  <ng-container *ngIf="currentPartner !== null && currentPartner !== 'NONE'">
    <img class="partnership-with partner-logo airline-logo-full" [src]="'./images/airline-logo-full/' + currentPartner + '.svg'" [alt]="currentPartner + ' logo'" />
  </ng-container>
</div>
<div class="item__row item__alignCenter item__justifyContentSpace">
  <span class="item__ref">
    {{ bookingDetails.bookingReference }}
  </span>
  <!-- remove arrving early 13601 -->
  <span *ngIf="bookingDetails.bookingJourneyStatusMMB !== 12" [class]="bookingListstatus[bookingDetails.bookingJourneyStatusMMB].className + ' item__status'"
    [style.background]="bookingListstatus[bookingDetails.bookingJourneyStatusMMB].background">
      {{appCopy.panelHeader[bookingListstatus[bookingDetails.bookingJourneyStatusMMB].status +selectedLanguage]}}
  </span>
</div>
<div class="item__highlight">
  <div class="item__highlight-icon">
    <span class="icon-car"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
  </div>
  <div class="item__highlight-content">
    <span>{{ appCopy.panelHeader[productTitle+selectedLanguage] }}</span>
    <span>
      {{ appCopy.panelHeader[productAction1+selectedLanguage] }}
      <!-- {{ appCopy.panelHeader[productAction2+selectedLanguage] }} -->
      {{productAction2_2}}
    </span>
  </div>
</div>
</div>
<div class="alert alert-info-light border-radius-large margin-bottom-24" style="display: none;">
  <!-- <h4 class="margin-top-0">
  </h4> -->
  <div class="partner-logo">
    <div *ngIf="currentPartner === null || currentPartner === 'NONE'">
      <!-- <span>{{ appCopy.panelHeader['togetherWithText'+selectedLanguage] }}</span> -->
      <img class="partner-logo__img airline-logo-full" [ngClass]="airlinePartnerLogoName" [src]="getAirlineLogoUrl(productData.airlineName)" [alt]="productData.airlineName + ' logo'" />
    </div>
    <div *ngIf="currentPartner !== null && currentPartner !== 'NONE'">
      <!-- <span class="serviced-by">Serviced by</span>
      <span class="serviced-by partner-logo__img logo-AIRPORTR"></span> -->

      <!-- <span class="partnership-with">{{ appCopy.panelHeader['inPartnerWithText'+selectedLanguage] }}</span> -->
      <img class="partnership-with partner-logo airline-logo-full" [src]="'./images/airline-logo-full/' + currentPartner + '.svg'" [alt]="currentPartner + ' logo'" />
    </div>
  </div>

  <hr class="margin-top-16 margin-bottom-16">
  <div class="media">
    <div class="media-left media-middle">
      <i class="sprite" [ngClass]="productIcon"></i>
    </div>
    <div class="media-body media-middle">
      <h5 class="margin-top-0 margin-bottom-0">
    {{ appCopy.panelHeader[productTitle+selectedLanguage] }}

      </h5>
      <p>
        {{ appCopy.panelHeader[productAction1+selectedLanguage] }}
        {{ appCopy.panelHeader[productAction2+selectedLanguage] }}
        {{productAction2_2}}
      </p>
    </div>
  </div>
</div>
